var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104.9 85.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #0a366b;\n      }\n\n      .cls-3 {\n        fill: #00b3ca;\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 11.3,
    height: 38.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.8,38.2h-2.5l3.3-9.8h3.1l3.3,9.8h-2.5l-2.3-7.3h0l-2.3,7.3h0ZM82.5,34.4h5.3v1.8h-5.3v-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.1,30.4v-1.9h8.3v1.9h-3v7.9h-2.3v-7.9h-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.5,38.2v-9.8h2.4v7.9h4.1v1.9s-6.5,0-6.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.3,28.5h2.4v6.3c0,.7-.2,1.4-.5,1.9s-.8,1-1.5,1.3c-.6.3-1.3.4-2.2.4s-1.6,0-2.2-.4c-.6-.3-1.1-.7-1.4-1.3-.3-.5-.5-1.2-.5-1.9v-6.3h2.4v6.1c0,.3,0,.6.2.9,0,.3.4.5.6.6.3,0,.6.2.9.2s.7,0,.9-.2c.3,0,.5-.4.6-.6,0-.3.2-.6.2-.9v-6.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.4,31.4c0-.4-.2-.6-.4-.8-.2-.2-.6-.3-1.1-.3s-.6,0-.8.1c-.2,0-.4.2-.5.3,0,.1-.2.3-.2.5v.4c0,.1.2.2.3.3,0,0,.3.2.5.2s.4,0,.6.2l.8.2c.5,0,.9.2,1.3.4.4.2.7.4.9.6.3.2.4.5.6.8,0,.3.2.7.2,1.1,0,.6-.2,1.1-.5,1.6-.3.4-.8.8-1.3,1-.6.2-1.3.4-2.1.4s-1.5,0-2.1-.4c-.6-.2-1.1-.6-1.4-1.1-.3-.5-.5-1.1-.5-1.9h2.3c0,.3,0,.6.3.8,0,.2.4.4.6.5.3,0,.6.2.9.2h.8c.2,0,.4-.2.5-.4s.2-.3.2-.5,0-.3-.2-.5-.3-.2-.5-.3c-.2,0-.5-.2-.9-.3l-1-.2c-.8-.2-1.5-.5-2-.9s-.7-1-.7-1.8.2-1.1.5-1.6.8-.8,1.4-1.1,1.2-.4,2-.4,1.4.1,2,.4,1,.6,1.3,1.1.5,1,.5,1.6h-2.3v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.2,28.5v9.8h-2l-3.9-5.6h0v5.6h-2.4v-9.8h2l3.9,5.6h0v-5.6s2.4,0,2.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.1,33.3c0,1.1-.2,2-.6,2.7-.4.7-1,1.3-1.7,1.7s-1.5.6-2.4.6-1.7-.2-2.4-.6-1.3-1-1.7-1.7c-.4-.7-.6-1.7-.6-2.7s.2-2,.6-2.7,1-1.3,1.7-1.7,1.5-.6,2.4-.6,1.7.2,2.4.6c.7.4,1.3,1,1.7,1.7s.6,1.7.6,2.7ZM31.7,33.3c0-.6,0-1.2-.3-1.6-.2-.4-.4-.8-.8-1-.3-.2-.7-.3-1.2-.3s-.9.1-1.2.3c-.3.2-.6.6-.8,1-.2.4-.3,1-.3,1.6s0,1.2.3,1.6c.2.4.4.8.8,1,.3.2.7.3,1.2.3s.9,0,1.2-.3c.3-.2.6-.6.8-1,.2-.4.3-1,.3-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.1,32h-2.4c0-.2,0-.5-.2-.7,0-.2-.2-.4-.4-.5-.2-.1-.4-.2-.6-.3-.2,0-.5-.1-.7-.1-.5,0-.9.1-1.2.3-.3.2-.6.6-.8,1-.2.4-.3,1-.3,1.6s0,1.2.3,1.6c.2.4.5.8.8,1s.7.3,1.2.3h.7c.2,0,.4-.2.6-.3s.3-.3.4-.5.2-.4.2-.6h2.4c0,.4-.2.9-.4,1.3s-.5.8-.9,1.2c-.4.3-.8.6-1.3.8s-1.1.3-1.8.3-1.7-.2-2.4-.6c-.7-.4-1.2-1-1.7-1.7-.4-.7-.6-1.7-.6-2.7s.2-2,.6-2.7c.4-.7,1-1.3,1.7-1.7.7-.4,1.5-.6,2.4-.6s1.1,0,1.6.2.9.4,1.3.7c.4.3.7.7.9,1.2.2.5.4,1,.4,1.6h.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.7,24.8h-2.5l3.3-9.8h3.1l3.3,9.8h-2.5l-2.3-7.3h0l-2.3,7.3h0ZM95.3,20.9h5.3v1.8h-5.3v-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.7,15h2.9l2.5,6.1h0l2.5-6.1h2.9v9.8h-2.3v-6h0l-2.4,5.9h-1.5l-2.4-6h0v6h-2.3v-9.8h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.8,15v9.8h-2.4v-9.8s2.4,0,2.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.5,15l1.8,3.1h0l1.8-3.1h2.6l-3,4.9,3,4.9h-2.7l-1.8-3.1h0l-1.8,3.1h-2.7l3-4.9-3-4.9s2.8,0,2.8,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.9,19.9c0,1.1-.2,2-.6,2.7s-1,1.3-1.7,1.7c-.7.4-1.5.6-2.4.6s-1.7-.2-2.4-.6-1.3-1-1.7-1.7-.6-1.7-.6-2.7.2-2,.6-2.7c.4-.7,1-1.3,1.7-1.7s1.5-.6,2.4-.6,1.7.2,2.4.6c.7.4,1.3,1,1.7,1.7.4.7.6,1.7.6,2.7ZM62.5,19.9c0-.6,0-1.2-.3-1.6-.2-.4-.4-.8-.8-1-.3-.2-.7-.3-1.2-.3s-.9.1-1.2.3c-.3.2-.6.6-.8,1s-.3,1-.3,1.6,0,1.2.3,1.6c.2.4.4.8.8,1,.3.2.7.3,1.2.3s.9-.1,1.2-.3c.3-.2.6-.6.8-1s.3-1,.3-1.6ZM59.4,14.1l1-2.2h2.1l-1.4,2.2s-1.7,0-1.7,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.3,24.8v-9.8h4c.7,0,1.4.1,1.9.4.5.3.9.6,1.2,1.1.3.5.4,1.1.4,1.7s0,1.3-.4,1.7c-.3.5-.7.8-1.3,1.1-.5.2-1.2.4-1.9.4h-2.6v-1.9h2.1c.4,0,.7,0,.9-.1.2,0,.4-.2.5-.4,0-.2.2-.4.2-.7s0-.6-.2-.8c0-.2-.3-.4-.5-.4-.2-.1-.5-.2-.9-.2h-1.2v7.9h-2.4.2ZM51.9,20.3l2.4,4.5h-2.6l-2.4-4.5h2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.2,24.8v-9.8h4c.7,0,1.4.1,1.9.4.5.3.9.7,1.2,1.2s.4,1.1.4,1.8,0,1.3-.4,1.8c-.3.5-.7.9-1.3,1.2-.5.3-1.2.4-1.9.4h-2.5v-1.9h2.1c.4,0,.7,0,.9-.2.2-.1.4-.3.5-.5s.2-.5.2-.8,0-.6-.2-.8c0-.2-.3-.4-.5-.5s-.5-.2-.9-.2h-1.2v7.9h-2.4s0,0,.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.6,15h2.4v6.3c0,.7-.2,1.4-.5,1.9s-.8,1-1.5,1.3c-.6.3-1.3.4-2.2.4s-1.6-.1-2.2-.4-1.1-.7-1.4-1.3c-.3-.5-.5-1.2-.5-1.9v-6.3h2.4v6.1c0,.3,0,.6.2.9.1.3.4.5.6.6.3.1.6.2.9.2s.7,0,.9-.2c.3-.1.5-.4.6-.6.1-.3.2-.6.2-.9v-6.1s.1,0,.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.9,16.9v-1.9h8.3v1.9h-3v7.9h-2.3v-7.9h-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.6,11.3h-2.5l3.3-9.8h3.1l3.3,9.8h-2.5l-2.3-7.3h0l-2.3,7.3h0ZM71.3,7.5h5.3v1.8h-5.3v-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.2,11.3V1.5h4c.7,0,1.4.1,1.9.4.5.3.9.6,1.2,1.1.3.5.4,1.1.4,1.7s0,1.3-.4,1.7c-.3.5-.7.8-1.3,1.1-.5.2-1.2.4-1.9.4h-2.6v-1.9h3c.2,0,.4-.2.5-.4,0-.2.2-.4.2-.7s0-.6-.2-.8c0-.2-.3-.4-.5-.4s-.5-.2-.9-.2h-1.2v7.9h-2.4.2ZM65.7,6.9l2.4,4.5h-2.6l-2.4-4.5s2.6,0,2.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.5,11.3h-2.5l3.3-9.8h3.1l3.3,9.8h-2.5l-2.3-7.3h0l-2.3,7.3h0ZM51.2,7.5h5.3v1.8h-5.3v-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.4,11.3V1.5h4c.7,0,1.4.1,1.9.4.5.3.9.7,1.2,1.2s.4,1.1.4,1.8,0,1.3-.4,1.8c-.3.5-.7.9-1.3,1.2-.5.3-1.2.4-1.9.4h-2.5v-1.9h2.1c.4,0,.7,0,.9-.2.2,0,.4-.3.5-.5s.2-.5.2-.8,0-.6-.2-.8c0-.2-.3-.4-.5-.5s-.5-.2-.9-.2h-1.2v7.9h-2.4s0,0,.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.7,11.3V1.5h6.8v1.9h-4.5v2h4.1v1.9h-4.1v2h4.5v1.9h-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.4,11.3V1.5h4c.7,0,1.4.1,1.9.4.5.3.9.6,1.2,1.1.3.5.4,1.1.4,1.7s-.1,1.3-.4,1.7c-.3.5-.7.8-1.3,1.1-.5.2-1.2.4-1.9.4h-2.6v-1.9h3c.2,0,.4-.2.5-.4.1-.2.2-.4.2-.7s0-.6-.2-.8c-.1-.2-.3-.4-.5-.4s-.5-.2-.9-.2h-1.2v7.9h-2.4.2,0ZM28.9,6.9l2.4,4.5h-2.6l-2.4-4.5s2.6,0,2.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.2,11.3V1.5h4c.7,0,1.4.1,1.9.4.5.3.9.7,1.2,1.2.3.5.4,1.1.4,1.8s-.1,1.3-.4,1.8-.7.9-1.3,1.2c-.5.3-1.2.4-1.9.4h-2.5v-1.9h2.1c.4,0,.7,0,.9-.2.2,0,.4-.3.5-.5s.2-.5.2-.8,0-.6-.2-.8c-.1-.2-.3-.4-.5-.5s-.5-.2-.9-.2h-1.2v7.9h-2.4,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-50",
    className: "cls-3",
    d: "M10.3,19.8c0,2.7-2.2,4.9-4.9,4.9S.6,22.5.6,19.8s2.2-4.9,4.9-4.9,4.9,2.2,4.9,4.9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-53",
    className: "cls-3",
    d: "M10.3,6.1c0,2.7-2.2,4.9-4.9,4.9S.6,8.8.6,6.1,2.8,1.3,5.5,1.3s4.9,2.2,4.9,4.9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-56",
    className: "cls-3",
    d: "M.6,33.4v4.9h4.9c2.7,0,4.9-2.2,4.9-4.9s-2.2-4.9-4.9-4.9-4.9,2.2-4.9,4.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.9,83.6v-41.3h10.1v16.4h16.4v-16.4h10.1v41.3h-10.1v-16.4h-16.4v16.4s-10.1,0-10.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.9,42.7v41.3h-10.1v-41.3h10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.9,42.7l9.3,30.3h0l9.3-30.3h11l-13.9,41.3h-13.1L.6,42.7h11.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.9,28.4h1.4l1.2,2.9h0l1.2-2.9h1.4v4.6h-1.1v-2.8h0l-1.1,2.8h-.7l-1.1-2.8h0v2.9h-1.1v-4.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.4,29.3v-.9h3.9v.9h-1.4v3.7h-1.1v-3.7s-1.4,0-1.4,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9c69bfd7fac31998e3a7615a766482c7.svg";
export { ForwardRef as ReactComponent };